import '@babel/polyfill'
import Vue from 'vue'
import EventBus from './js/Config'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import axiosApi from 'axios';

Vue.prototype.$bus = EventBus
const axios = axiosApi.create({
    baseURL: window.location.origin + '/api/',
    //baseURL: 'http://localhost/my-epet/api/',
    withCredentials: true
});
window.axios = axios;
window.pageHeader;
//Vue.config.productionTip = true
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
